/**
 * La boîte d'un envoi refusé — ce que l'ancien `useApiStatus` montrait (« Erreur » et la phrase du
 * serveur) pour une écriture que la page du design system ne sait pas dire elle-même.
 */
import React from "react"

import { ConfirmDialog } from "../../../../../../design-system"

export function TutorSendErrorDialog(props: { message: string | null; onDismiss: () => void }) {
    const { message, onDismiss } = props
    return (
        <ConfirmDialog
            visible={message != null}
            title="Erreur"
            message={message ?? undefined}
            confirmLabel="OK"
            danger={false}
            hideCancel
            onConfirm={onDismiss}
            onCancel={onDismiss}
        />
    )
}
